import antdData from 'antd/lib/locale-provider/en_US'
import {createIntl, createIntlCache} from 'react-intl'

const messages = {
  // TITLES
  'title.main': 'Main',
  'title.news': 'News',
  'title.legal': 'Legal information',
  'title.partners': 'My partners',
  'title.journal': 'My journal',
  'title.finance': 'Finance',
  'title.referral-links': 'My links',
  'title.photobank': 'Photobank',
  'title.videobank': 'Videobank',
  'title.files': 'Files',
  'title.sales-report': 'Sales report',
  'title.diagnostician-materials': 'Diagnostics',
  // MENU
  'menu.left.profile.available': 'Available',
  'menu.left.profile.income': 'Expected payout',
  'menu.left.profile.business-reputation': 'Business Reputation',
  'menu.left.profile.business-reputation-info-tooltip': 'Information about this indicator',
  'menu.left.logout': 'Log out',
  'menu.left.goto-masterkit': 'To MasterKit',
  'menu.left.marketing-plan': 'Marketing plan',
  'menu.left.support': 'Support Service',
  'menu.left.useful-materials': 'Useful Stuff',
  // DIAGNOSTICS
  'menu.left.diagnostics.title': 'Diagnostics sold',
  'menu.left.diagnostics.details.last7Days': 'in the last 7 days',
  'menu.left.diagnostics.details.last30Days': 'in the last 30 days',
  'menu.left.diagnostics.details.total': 'total',
  'menu.left.profileSnippet.diagnostics.top': 'TOP',
  // ACTIVATION
  'menu.left.profile.activation.title': 'Activation',
  'menu.left.profile.activation.notExecuted': 'Not executed',
  'menu.left.profile.activation.daysLeft': '{daysLeft, plural, one {# day left} other {# days left}}',
  'menu.left.profile.activation.expiresAt': 'Expires at \n{date}',
  // SETTINGS
  'components.locale-settings-modal.title': 'Select Language',
  'components.locale-settings-modal.change-confirm': 'Change the Language to {language}?',
  'components.locale-settings-modal.change-confirm.yes': 'Yes',
  'components.locale-settings-modal.change-confirm.no': 'Cancel',
  'components.legal-info.download-document': 'Download document',
  'locales.russian': 'Russian',
  'locales.english': 'English',
  'locales.bulgarian': 'Bolgarian',
  'locales.french': 'French',
  'locales.deutsch': 'German',
  'locales.hungarian': 'Hungarian',
  'locales.italian': 'Italian',
  'locales.kazakh': 'Kazakh',
  'locales.latvian': 'Latvian',
  'locales.spanish': 'Spanish',
  'locales.turkish': 'Turkish',
  // COMMON Components
  'components.profile-snippet.logout': 'Log out',
  'components.commissions-modal.title': 'Commission details',
  'components.commissions-modal.table.user': 'To whom',
  'components.commissions-modal.table.level': 'Level',
  'components.commissions-modal.table.date': 'Date',
  'components.commissions-modal.table.product': 'Product',
  'components.commissions-modal.table.commission': 'Volume',
  'components.commissions-modal.table.percent': 'Percentage',
  'components.commissions-modal.table.amount': 'Amount',
  'components.commissions-modal.table.status': 'Status',
  'components.commissions-modal.table.user.external': 'The user may be out of your network',
  'components.cookies-policy-agreement.text': 'This website uses cookies, unique digital identifiers, to collect and store information that helps us to personalize your experience and functions of the site. Your information is never shared to third parties for any purpose. For a detailed explanation see our Confidentiality and Cookies policies.',
  'components.cookies-policy-agreement.agree-button': 'I agree ',
  'components.cookies-policy-agreement.docs-link-text': "See our policies",
  'components.commissions-modal.status.active': 'In the process',
  'components.commissions-modal.status.rejected': 'Canceled',
  'components.commissions-modal.status.paid_out': 'Performed',
  'components.rich-progress-bar.percentage-of-completion': '{percent}% done',
  'components.card-select.add-new': 'Add new credit card',
  'components.remove-card.tooltip': 'Remove card',
  'components.remove-card.success-message': 'Credit card deleted successfully',
  'components.remove-card.warning-text': 'All unfinished operations\nassociated with this card will be canceled',
  'components.remove-card.confirmation-text': 'Remove credit card?',
  'components.remove-card.yes': 'Yes',
  'components.remove-card.cancel': 'Cancel',
  // COMMON Components - error-boundary
  'components.error-boundary.title': 'An error has occurred in the module',
  'components.error-boundary.message-sent': 'We will troubleshoot it as soon as possible',
  'components.error-boundary.you-can': 'You can',
  'components.error-boundary.re-login': 'Log in again',
  'components.error-boundary.or': 'or',
  'components.error-boundary.refresh-page': 'Refresh the page',
  'components.error-boundary.solve-yourself': ' to try resolving the problem yourself.',
  // Notifications
  'notifications.empty': 'No new notifications',
  'notifications.notification.remittance.incoming.title': 'Incoming transaction {amount}',
  'notifications.notification.remittance.incoming.description': 'от {fullname}',
  'notifications.notification.remittance.outgoing.title': 'Transaction completed {amount}',
  'notifications.notification.remittance.outgoing.description': 'to user {fullname}',
  'notifications.notification.goal-report.income.title': 'Goal report received',
  'notifications.notification.goal-report.income.description': 'Goal: get income',
  'notifications.notification.goal-report.qualification.title': 'Goal report received',
  'notifications.notification.goal-report.qualification.description': 'Goal: get new qualification',
  'notifications.notification.withdrawal.title': 'Withdraw funds',
  'notifications.notification.withdrawal.approved': 'Operation confirmed',
  'notifications.notification.withdrawal.rejected': 'Operation rejected',
  'notifications.notification.withdrawal.canceled': 'Operation canceled',
  'notifications.notification.survey.title': 'You need to take a survey',
  'notifications.notification.diagnostician-certificate.granted': 'Вы прошли аттестацию\nТеперь вы можете проводить диагностику',
  'notifications.notification.diagnostician-certificate.revoked': 'Ваша аттестация отозвана\nВы больше не можете проводить диагностику',
  // QUALIFICATIONS
  'qualification.client': 'Client',
  'qualification.intern': 'Trainee',
  'qualification.partner': 'Partner',
  'qualification.official_partner': 'Official partner',
  'qualification.mentor': 'Sponsor',
  'qualification.regional_mentor': 'Regional business sponsor',
  'qualification.international_mentor': 'International business sponsor',
  'qualification.top_leader': 'Top leader',
  'qualification.shareholder': 'Shareholder',
  'qualification.business_mentor': 'Business sponsor',
  'qualification.lead_shareholder': 'Lead shareholder',
  'qualification.regional_mentor_first_month': 'Regional business sponsor ( 1 month)',
  'qualification.shareholder_first_month': 'Shareholder (1 month)',
  'qualification.shareholder_second_month': 'Shareholder (2 monthes)',
  'qualification.top_leader_first_month': 'Top leader (1 month)',
  'qualification.top_leader_second_month': 'Top leader (2 monthes)',
  'qualification.international_mentor_first_month': 'International business sponsor (1 month)',
  'qualification.curator': 'Куратор',
  'qualification.organizer': 'Организатор',
  'qualification.practitioner': 'Игро-Практик',
  'qualification.community_ambassador': 'Амбассадор сообщества',
  'qualification.brend_ambassador': 'Амбассадор бренда',
  'qualification.company_ambassador': 'Амбассадор Компании',
  // LOGIN PAGE
  'page.login.title': 'Log In',
  'page.login.login': 'Username',
  'page.login.phone': 'Phone number',
  'page.login.by-login': 'Use username to log in',
  'page.login.by-phone': 'Use phone to log in',
  'page.login.password': 'Password',
  'page.login.login-required': 'Enter your username',
  'page.login.phone-required': 'Enter your phone number',
  'page.login.password-required': 'Enter your password',
  'page.login.submit-text': 'Enter',
  // 'page.login.error': 'Error',
  'page.login.auth-wrong-pass-or-login-text': 'Incorrect username or password',
  'page.login.auth-wrong-pass-or-phone-text': 'Incorrect phone number or password',
  'page.login.auth-error-text': 'Authorization error occurred',
  // Verification
  'verification.title': 'Getting Started',
  'verification.step-0.welcome': 'Welcome to Super Ego Business',
  'verification.step-0.3-steps': 'Before we get started, you need to complete 3 steps',
  'verification.step-0.start': 'Start',
  'verification.step-1.title': 'Step 1',
  'verification.step-1.agreement.heading': 'Agreement',
  'verification.step-1.agreement.description': 'All relations between Super Ego and the partners are governed by the Agreement. To continue, you must read and accept the terms of the Agreement.',
  'verification.step-1.i-agree': 'I accept the terms of the Agreement',
  'verification.step-1.download-pdf': 'Download PDF file',
  'verification.step-1.next': 'Next',
  'verification.step-2.title': 'Step 2',
  'verification.step-2.living-city': 'City of residence',
  'verification.step-2.city-select-text': 'Please enter your city of residence in the field below and select from the drop-down list',
  'verification.step-2.type-living-city': 'Enter the city of residence',
  'verification.step-2.next': 'Next',
  'verification.step-2.living-country': 'Country of residence',
  'verification.step-2.your-living-country-is': 'You live in the country:',
  'verification.step-2.citezenship-question': 'Are you a citizen of this country and were your documents issued in this country?',
  'verification.step-2.yes': 'Yes',
  'verification.step-2.no': 'No',
  'verification.step-2.citezenship': 'Citizenship',
  'verification.step-2.citezenship-select-desc': 'If your documents were issued in another country, please specify the country of origin of your documents',
  'verification.step-2.type-citezensip': 'Enter your country of residence',
  'verification.step-3.title': 'Step 3',
  'verification.step-3.docs-upload': 'Downloading documents',
  // на перевод
  'verification.step-3.docs-upload-desc': 'In order to formalize our partnership, you need to download the following documents:',
  'verification.step-3.photos-note': 'To make the verification go faster, please make sure that your face and passport data are clearly visible in the photos.',
  'verification.step-3.docs-uploading': 'Downloading the list of required documents...',
  'verification.step-3.docs-upload-server-error': 'An error occurred while sending the documents to the server',
  'verification.step-3.i-agree': 'I agree with processing of my personal data',
  'verification.step-3.done': 'Done',
  'verification.step-3.choose-doc': 'Add a photo',
  'verification.step-3.id-card': 'Passport photo',
  'verification.step-3.photo-with-id-card': 'Selfie with your passport',
  'verification.step-4.loading': 'Loading',
  'verification.step-4.your-docs-on-review': 'Your documents are being checked.',
  'verification.step-4.verification-duration': 'Request can be processed in 1-2 days',
  'verification.step-4.description-1-line': 'As soon as the documents are checked,',
  'verification.step-4.description-2-line': 'you will be able to access to the Super Ego Business',
  'verification.step-4.verification-rejected': 'Verification not accepted',
  // на перевод
  'verification.step-4.retry': 'Go through verification process again',
  'verification.step-4.congrats': 'Congratulations!',
  // на перевод
  'verification.step-4.second-line-desc': 'Now you can get down to business',
  'verification.step-4.time-to-set-first-target': 'Let\'s set your first goal in Super Ego Business',
  'verification.step-4.set-target': 'Set a goal',
  'verification.step-4.skip-set-target': 'Skip',
  // CREATE GOAL
  'set-goal.title': 'Setting your goal',
  'set-goal.time-to-set-new-goal': 'It\'s time to set a new goal!',
  'set-goal.new-period-has-begun': 'A new period has begun',
  'set-goal.lets-set-goal': 'Let\'s set a goal!',
  'set-goal.set-goal-by-income': 'Set income goal',
  'set-goal.you-set-goal-by-income': 'You choosed income goal',
  'set-goal.dont-set': 'Skip goal setting this month',
  'set-goal.set-goal-by-qualification': 'Get the next qualification',
  'set-goal.you-set-goal-by-qualification': 'You chooset goal by qualification.',
  'set-goal.your-next-qualification': 'Your next qualification:',
  'set-goal.requerements.required-personal-sales': '{count, plural, one {# personal sale} other {# personal sales}} of Master Kit',
  'set-goal.requerements.required-income': 'Income from 2 to 5 level',
  'set-goal.requerements.title': 'Require conditions:',
  'set-goal.error-already-set': 'You\'ve already set a goal for this month',
  'set-goal.description': 'When taking the first steps in business, it is very important to set concrete, measurable and achievable goals. The goals in Super Ego Business are set every month.',
  'set-goal.income-amount-question': 'How much do you want to earn in {monthAndYear}?',
  'set-goal.amount-placeholder': 'Amount',
  'set-goal.by-income.prediction': 'It\'s about {sellsCount, plural, one {# sale} other {# sales}} Master Kit (depending on the cost of the package)',
  'set-goal.income.you-will-get': 'With each sale of Master Kit you will earn',
  'set-goal.submit': 'Set a goal',
  'set-goal.go-back': 'Go back',
  'set-goal.skip': 'Continue without a goal',
  'set-goal.skip-confirm-question': 'Are you sure you want to skip the goal setting step?',
  'set-goal.skip-confirm-description': 'Setting a goal helps you track your performance and keep your focus',
  'set-goal.skip-finish.heading-line-1': 'It\'s okay',
  'set-goal.skip-finish.heading-line-2': 'You can set a goal later',
  'set-goal.skip-finish.welcome': 'Welcome to the Partner Cabinet',
  'set-goal.skip-finish.go': 'Go to',
  'set-goal.success.great': 'Great!',
  'set-goal.success.goal-set': 'The goal is set',
  'set-goal.success.welcome': 'Welcome to the Partner Cabinet',
  'set-goal.success.go': 'Go to',
  // GOAL REPORT
  'goal-report.title': '{monthYear} goal report',
  'goal-report.not-found': 'Report not found',
  'goal-report.period-finished': 'The reporting period is over. Below are the totals for your goal.',
  'goal-report.your-goal': 'Your goal:',
  'goal-report.your-goal.get-income': 'Get income {amount}',
  'goal-report.your-goal.get-qualification': 'Get qualification «{expQualification}»',
  'goal-report.your-goal.qualification.current-result.required-personal-sales': 'Personal sales: {currentValue} out of {required}',
  'goal-report.your-goal.qualification.current-result.required-income': '2-5 level income: {currentValue} out of {required}',
  'goal-report.result.created': 'Goal not reached yet',
  'goal-report.result.unperformed': 'Sorry, you did not reach the goal',
  'goal-report.result.performed': 'Congratulations! You have successfully reached the goal',
  'goal-report.earnings': 'You earned {amount}',
  'goal-report.show-income-details': 'Show income details',
  'goal-report.go-next': 'Next',
  'goal-report.go-home-page': 'Go to Dashboard',
  // FOOTER
  'footer.rightsReserved': 'All rights reserved.',
  'footer.legal-information': 'Legal Information',
  'footer.show-support-chat-button': 'Support Service',
  // Refferal Links
  'page.ref-links.title': 'My links',
  'page.ref-links.description.line-1': 'Below there are your personal links to purchase pages, sites, etc.',
  'page.ref-links.description.line-2': 'Contacts of people who followed these links and left their data get in the journal. Copy them and send these links to people.',
  'page.ref-links.table-title.name': 'Title',
  'page.ref-links.table-title.link': 'Link',
  'page.ref-links.table-title.copying': 'Copying',
  'page.ref-links.table-action.copy': 'Copy',
  'page.ref-links.copy.success': 'The link copied',
  'page.ref-links.copy.error': 'Unable to copy the link, please copy it manually',
  // News
  'page.news.title': 'News',
  'page.news.go-to-list': 'To the news list',
  'page.news.published': 'Published',
  'page.news.other-news': 'Other news',
  'page.news.no-news-yet': 'No news yet',
  // Dashboard
  'page.dashboard.ancestors.title': 'Sponsor\'s information',
  'page.dashboard.ancestors.nodata': 'There\'s no sponsor',
  'page.dashboard.ancestors.showAll': 'Show all',
  'page.dashboard.ancestors.all': 'All the sponsors',
  'page.dashboard.ancestors.modal.table.level': 'Level',
  'page.dashboard.ancestors.modal.table.login': 'Username',
  'page.dashboard.ancestors.modal.table.name': 'Name',
  'page.dashboard.ancestors.modal.table.contacts': 'Contacts',
  'page.dashboard.goal.title': 'Your goal in {date}',
  'page.dashboard.goal.not-set': 'No goals set in the current month',
  'page.dashboard.goal.set-goal': 'Set your goal',
  'page.dashboard.goal.income.current-result': 'You have already earned',
  'page.dashboard.goal.qualification.current-result.required-personal-sales': 'Personal sales: {currentValue} out of {required}',
  'page.dashboard.goal.qualification.current-result.required-income': '2-5 level income: {currentValue} out of {required}',
  'page.dashboard.goal.get-qualification': 'Get qualification "{expQualification}"',
  'page.dashboard.goal.business-performance': 'Business indicators',
  'page.dashboard.goal.more-details': 'More details',
  'page.dashboard.finance-events.title': 'Financial operations',
  'page.dashboard.finance-events.show-all': 'Show all',
  'page.dashboard.finance-events.eventByRemittance-pretext': 'partner',
  'page.dashboard.finance-events.eventByReceipt-pretext': 'from',
  'page.dashboard.finance-events.eventByPayment-pretext': 'for',
  'page.dashboard.sales.title': 'Sales',
  'page.dashboard.sales.show-details': 'Show details',
  'page.dashboard.sales.from': 'from',
  'page.dashboard.sales.placeholder.no-sales': 'There are no sales in your branch yet',
  'page.dashboard.sales.placeholder.explore-marketing-plan': 'Learn Marketing Program',
  'page.dashboard.news.title': 'News',
  'page.dashboard.news.empty': 'No news yet',
  'page.dashboard.news.show-all': 'Show all',
  // Roadmap
  'roadmap.title': 'Roadmap',
  // FinanceEvents
  'finance-events.eventByRemittance': 'Outgoing transfer',
  'finance-events.eventByReceipt': 'Incoming transfer',
  'finance-events.eventByPayment': 'Payment',
  'finance-events.eventByWithdrawal': 'Withdrawal of funds',
  'finance-events.eventByPayout': 'Payback on commissions',
  'finance-events.eventByGift': 'Product payment to partner',
  // FINANCE
  'page.finance.title': 'Finance',
  'page.finance.eventByPayment-pretext': 'for',
  'page.finance.eventByRemittance-pretext': 'partner',
  'page.finance.eventByReceipt-pretext': 'from',
  'page.finance.filter.from': 'Time period from',
  'page.finance.filter.to': 'Time period to',
  'page.finance.filter.type': 'Type of operation',
  'page.finance.filter.reset': 'Reset filter',
  'page.finance.new-remittance.title': 'Transfer',
  'page.finance.new-remittance.destination-user': 'Recipient',
  'page.finance.new-remittance.type-destination-user-login': 'Enter the recipient\'s username',
  'page.finance.new-remittance.success-message': 'Request for money transfer sent successfully',
  'page.finance.new-remittance.note': 'Note',
  'page.finance.new-remittance.available-amount': 'Available for transfer',
  'page.finance.new-remittance.submit': 'Transfer',
  'page.finance.new-remittance.confirm-text': 'You\'re going to transfer:',
  'page.finance.new-remittance.ok-button': 'Confirm',
  'page.finance.new-remittance.cancel-button': 'Cancel',
  'page.finance.new-remittance.amount': 'Amount',
  'page.finance.new-remittance.submit-button': 'Make a transfer',
  'page.finance.new-remittance.alert.line-1': 'Transfer confirmation can take up to 24 hours.',
  'page.finance.new-remittance.alert.line-2': 'If the transfer was not confirmed for 24 hours, please contact support service.',
  'page.finance.new-remittance.alert.line-3': '',
  'page.finance.new-withdrawal.title': 'Withdrawal of funds',
  'page.finance.new-withdrawal.success-message': 'Request for withdrawal of funds sent successfully',
  'page.finance.new-withdrawal.withdrawal-type': 'Withdrawal method',
  'page.finance.new-withdrawal.note.placeholder.default': 'Note',
  'page.finance.new-withdrawal.note.placeholder.withdrawal-type-1': 'Your phone number',
  'page.finance.new-withdrawal.note.placeholder.withdrawal-type-2': 'Full name and phone',
  'page.finance.new-withdrawal.amount': 'Amount',
  'page.finance.new-withdrawal.available-amount': 'Available for withdrawal',
  'page.finance.new-withdrawal.next': 'Далее',
  'page.finance.new-withdrawal.confirm-text': 'You\'re going\nto make a withdrawal',
  'page.finance.new-withdrawal.confirm.commisiion-warning': 'A commission of 4%\nwill be taken from the specified amount',
  'page.finance.new-withdrawal.confirm-button': 'I confirm',
  'page.finance.new-withdrawal.cancel-button': 'Cancel',
  // 'page.finance.new-withdrawal.agreement': 'enWithdrawalAgreement', // dont translate
  'page.finance.new-withdrawal.agreement-description': 'Please read and accept the withdrawal conditions before filling in form.',
  'page.finance.new-withdrawal.exchange-rates-link-title': 'View current ECB exchange rates',
  'page.finance.new-withdrawal.i-agree': 'I accept the withdrawal conditions',
  'page.finance.new-withdrawal.go-next': 'Next',
  'page.finance.new-withdrawal.balance-limit-error': 'Not enough funds to withdraw',
  'page.finance.new-withdrawal.max-limit-error': 'Maximum withdrawal amount {value}',
  'page.finance.new-withdrawal.min-limit-error': 'Minimum withdrawal amount {value}',

  'page.finance.new-withdrawal.note': 'Additional information',
  'page.finance.new-withdrawal.note.withdrawal-type-1': 'To withdraw funds to a bank card, you must provide it\'s details.\nFill in the data and return to this page',
  'page.finance.new-withdrawal.note.withdrawal-type-1-button-caption': 'Fill in',
  'page.finance.new-withdrawal.note.withdrawal-type-2': 'To withdraw funds, legal entities must provide documents and bank details to {email}',
  'page.finance.new-withdrawal.to-bank-card': 'To credit card',
  'page.finance.new-withdrawal.to-checking-account': 'To checking account',
  'page.finance.new-withdrawal.no-cards-placeholder': 'You haven\'t added a credit card yet.',
  'page.finance.new-withdrawal.add-new-card': 'Add credit card',
  'page.finance.new-withdrawal.add-new-card.prevention': 'Your credit card data will be entered in a special payment service window.<br /><br />Data will save on the <a href="https://ecommpay.com/" target="_blank">ECOMMPAY</a>\'s side and stored securely in&nbsp;accordance&nbsp;with PCI DSS security standards.<br /><br />We will not have direct access to the data of your credit card.',
  'page.finance.new-withdrawal.add-new-card.input-card-data': 'Enter card details',
  'page.finance.new-withdrawal.add-new-card.cancel': 'Cancel',
  'page.finance.new-withdrawal.add-new-card.success': 'Card added successfully',
  'page.finance.details.eventByRemittance-pretext': 'To partner ',
  'page.finance.details.EventByReceipt-pretext': 'From partner ',
  'page.finance.details.commissions-details': 'Detailed commissions',
  'page.finance.details.commissions-details-button-caption': 'See',
  'page.finance.details.note': 'Comment',
  'page.finance.details.partner': 'Partner',
  'page.finance.details.date': 'Date of operation',
  'page.finance.details.state': 'Current status',
  'page.finance.details.id': 'Operation ID',
  'page.finance.event.status.waiting': 'Pending',
  'page.finance.event.status.approved': 'Done',
  'page.finance.event.status.rejected': 'Declined',
  'page.finance.event.status.canceled': 'Canceled',
  'page.finance.details.withdrawal-state-history.title': 'Status change history',
  'page.finance.details.withdrawal-state-history.date': 'Date',
  'page.finance.details.withdrawal-state-history.status': 'Status',
  'page.finance.details.withdrawal-state-history.reason': 'Comment',
  'page.finance.details.withdrawal-state-history.reason-not-set': 'Not specified',
  'page.finance.details.withdrawal-state-history.empty': 'No data',
  // Partners
  'page.partners.table.title.level': 'Level',
  'page.partners.table.title.partner': 'Partner',
  'page.partners.table.title.qualification': 'Qualification',
  'page.partners.table.title.first-line-income': 'First line income',
  'page.partners.table.title.total-income': 'Total income',
  'page.partners.table.title.goal': 'Goal',
  'page.partners.table.title.no-goal': 'There\'s no goal',
  'page.partners.table.title.goal.income': 'Get income {expAmount}',
  'page.partners.table.title.goal.qualification': 'Get qualification "{expQualification}"',
  'page.partners.table.title.updated': 'Updated',
  'page.partners.table.title.details': 'More details',
  'page.partners.table.title.show-details': 'Show details',
  'page.partners.table.title.load-more': 'Show more',
  'page.partners.filter.period': 'Set period',
  'page.partners.filter.active-period': 'Active period',
  'page.partners.filter.qualifications': 'Qualification',
  'page.partners.filter.search': 'Search',
  'page.partners.filter.search-placeholder': 'Type username, phone or email',
  'page.partners.filter.level': 'Levels',
  'page.partners.filter.all-goals': 'All goals',
  'page.partners.filter.goal-by-income': 'Income goal',
  'page.partners.filter.goal-by-qualification': 'Qualification Goal',
  'page.partners.filter.all': 'All',
  'page.partners.filter.favorite': 'Favorites',
  'page.partners.filter.new': 'New',
  'page.partners.filter.hide-innactive': 'Hide inactive',
  'page.partners.filter.hide-innactive-tip' :'Hide partners who didn\'t set a goal, or who haven\'t income in the selected period',
  'page.partners.filter.reset': 'Reset filter',
  'page.partners.details.title': 'Business indicators',
  'page.partners.details.remove-from-favorites': 'Remove from favorites',
  'page.partners.details.add-to-favorites': 'Add to favorites',
  'page.partners.details.show-mentors': 'Show mentors',
  'page.partners.details.state.unverified': 'Not verified',
  'page.partners.details.state.active': 'Verified',
  'page.partners.details.state.blocked': 'Inactive',
  'page.partners.details.in-business-since': 'Master Kit is purchased',
  'page.partners.details.no-goal': 'Goal not set',
  'page.partners.details.goal-income': 'Goal: get income {amount}',
  'page.partners.details.goal-qualification': 'Goal: get qualification "{expQualification}"',
  'page.partners.details.set-period': 'Set period',
  'page.partners.details.personal-sales': 'Personal sales',
  'page.partners.details.personal-sales-description': 'The number of sales made via your referral link in the specified period',
  'page.partners.details.personal-sales-left': 'You must complete {personalSalesLeft, plural, one {# personal sale} other {# personal sales}} or more of the base package',
  'page.partners.details.out-of': 'out of',
  'page.partners.details.income-second-to-fifth-level': 'Income from levels 2 to 5',
  'page.partners.details.income-second-to-fifth-level-description': 'Revenue from sales from the 2nd to 5th lines in the specified period',
  'page.partners.details.income-second-to-fifth-level-left': 'Income {value} from levels 2 to 5 is required',
  'page.partners.details.approved-qualification': 'Proven qualification',
  'page.partners.details.approved-qualification-description': 'Proven qualification at the beginning of the period',
  'page.partners.details.income': 'Total income',
  'page.partners.details.income-description': 'Income from the entire network for the specified period',
  'page.partners.details.show-income-details': 'Show details',
  'page.partners.details.first-line-income': 'Income from 1st line',
  'page.partners.details.first-line-income-desc': 'Income from the 1st line sales for the specified period',
  'page.partners.details.second-to-fifth-level-income': 'Income from levels 2 to 5',
  'page.partners.details.second-to-fifth-level-income-desc': 'Income from sales from the 2nd to 5th lines in the specified period',
  'page.partners.details.personale-sales': 'Personal sales',
  'page.partners.details.personale-sales-desc': 'Number of sales of basic packages for the specified period',
  'page.partners.details.personal-turnover': 'Personal volume',
  'page.partners.details.personal-turnover-desc': 'Total number of sales points in the first line for the specified period',
  'page.partners.details.group-turnover': 'Group volume',
  'page.partners.details.group-turnover-desc': 'Total number of sales points in the whole network for the specified period',
  'page.partners.details.income-from-strong-branch': 'Strong line income',
  'page.partners.actions.leftContacts': 'Left the contact details',
  'page.partners.actions.meeting': 'Meeting',
  'page.partners.actions.call': 'Call',
  'page.partners.actions.downloadedBook': 'Downloaded a book',
  'page.partners.actions.registeredOnSite': 'Registration on the site',
  'page.partners.actions.boughtProduct': 'Bought a product',
  'page.partners.actions.becamePartner': 'Became a partner',
  'page.partners.actions.other': 'Other things',
  // Journal
  'page.journal.tabs.contacts': 'Contacts',
  'page.journal.tabs.tasks': 'Tasks',
  'page.journal.tabs.favorites': 'Favorites',
  'page.journal.tabs.archive': 'Archive',
  'page.journal.table.lastActivity': 'Activity',
  'page.journal.table.time': 'Time',
  'page.journal.table.contact': 'Contact',
  'page.journal.table.phone': 'Phone number',
  'page.journal.table.is-shared': 'Contact received from your partner',
  'page.journal.add-new.add-contact': 'Add new contact',
  'page.journal.add-new.contact-adding': 'Adding a new contact',
  'page.journal.add-new.error': 'An error occurred when adding a contact',
  'page.journal.add-new.required-field-message': 'Please fill in the field',
  'page.journal.add-new.type-name': 'Enter a name',
  'page.journal.add-new.incorrect-email-message': 'Enter the correct email',
  'page.journal.add-new.type-email': 'Enter your email',
  'page.journal.add-new.type-phone': 'Enter the phone number',
  'page.journal.add-new.type-note': 'Add a note',
  'page.journal.group-actions.title': 'Actions with selected',
  'page.journal.group-actions.archive.restore': 'Restore from archive',
  'page.journal.group-actions.archive.move-to-archive': 'Move to archive',
  'page.journal.group-actions.favorites.remove': 'Remove from favorites',
  'page.journal.group-actions.favorites.add': 'Add to favorites',
  'page.journal.group-actions.change-owner.send': 'Transfer to partner',
  'page.journal.group-actions.reset-selection': 'Reset selection',
  'page.journal.group-actions.favorites.remove.confirm': 'Are you sure want to remove {count, plural, one {# contact} other {# contacts}} from your favorites list?',
  'page.journal.group-actions.favorites.add.confirm': 'Are you sure want to add {count, plural, one {# contact} other {# contacts}} to your favorites list?',
  'page.journal.group-actions.favorites.remove.success-message': '{count, plural, one {# contact} other {# contacts}} successfully removed from your favorites list',
  'page.journal.group-actions.favorites.add.success-message': '{count, plural, one {# contact} other {# contacts}} successfully added to your favorites list',
  'page.journal.group-actions.favorites.submit': 'Yes',
  'page.journal.group-actions.favorites.cancel': 'Cancel',
  'page.journal.group-actions.archive.restored.success-message': '{count, plural, one {# contact} other {# contacts}} succesfully restored from archive',
  'page.journal.group-actions.archive.archived.success-message': '{count, plural, one {# contact} other {# contacts}} succesfully removed to archive',
  'page.journal.group-actions.archive.restore.confirm': 'Are you sure want to restore {count, plural, one {# contact} other {# contacts}} from archive?',
  'page.journal.group-actions.archive.archive.confirm': 'Are you sure want to remove {count, plural, one {# contact} other {# contacts}} to archive?',
  'page.journal.group-actions.archive.submit': 'Yes',
  'page.journal.group-actions.archive.cancel': 'Cancel',
  'page.journal.group-actions.change-owner.no-forward-shared-text': 'Among the selected contacts are those that have been transferred to you from your partners. Such contacts are not available for further transfer.',
  'page.journal.group-actions.change-owner.description': 'Which partner you want to transfer {count, plural, one {# contact} other {# contacts}}?',
  'page.journal.group-actions.change-owner.success': '{count, plural, one {# contact} other {# contacts}} successfully transferred to partner {name}',
  'page.journal.group-actions.change-owner.partner': 'Partner',
  'page.journal.group-actions.change-owner.placeholder': 'Type partner\'s username',
  'page.journal.group-actions.change-owner.send-button': 'Transfer',
  'page.journal.group-actions.change-owner.confirm-text': 'You are going to transfer {count, plural, one {# contact} other {# contacts}}\nto partner {name}.\n{count, plural, one {Contact} other {Contacts}} will remove from your journal.\nConfirm the operation?',
  'page.journal.group-actions.change-owner.cancel': 'Cancel',
  'page.journal.group-actions.change-owner.i-confirm': 'I confirm',
  'page.journal.details.actions.title': 'Contact\'s actions',
  'page.journal.details.actions.today': 'today',
  'page.journal.details.actions.yesterday': 'yesterday',
  'page.journal.details.actions.created-by-you': 'Added by you',
  'page.journal.details.actions.new-action.error': 'An error occurred when adding a touch',
  'page.journal.details.actions.new-action.description': 'Description',
  'page.journal.details.actions.new-action.action-type': 'Touch type',
  'page.journal.details.actions.new-action.save': 'Save',
  'page.journal.details.actions.new-action.cancel': 'Cancel',
  'page.journal.details.actions.new-action.new-action': 'A new touch',
  'page.journal.details.actions.new-action.add-action': 'Add new touch',
  'page.journal.details.edit.error': 'There was an error while editing',
  'page.journal.details.edit.name': 'Name',
  'page.journal.details.edit.phone': 'Phone number',
  'page.journal.details.edit.note': 'Note',
  'page.journal.details.edit.submit': 'Save',
  'page.journal.details.edit.cancel': 'Cancel',
  'page.journal.details.edit.title': 'Editing',
  'page.journal.details.tags.tag-name':'Tag title',
  'page.journal.details.tags.submit': 'Add',
  'page.journal.details.tags.cancel': 'Cancel',
  'page.journal.details.tags.add-tag': 'Add tag',
  'page.journal.details.tasks.title': 'My tasks',
  'page.journal.details.tasks.yesterday': 'yesterday',
  'page.journal.details.tasks.today': 'yesterday',
  'page.journal.details.tasks.tomorrow': 'tomorrow',
  'page.journal.details.new-task.error': 'An error occurred when adding a task',
  'page.journal.details.new-task.deadline': 'Deadline',
  'page.journal.details.new-task.task-name': 'Task',
  'page.journal.details.new-task.description': 'Description',
  'page.journal.details.new-task.submit': 'Save',
  'page.journal.details.new-task.cancel': 'Cancel',
  'page.journal.details.new-task.create': 'New task',
  'page.journal.details.task.result': 'What\'s the result?',
  'page.journal.details.task.finish': 'Complete',
  'page.journal.details.task.cancel': 'Cancel',
  'page.journal.details.remove-from-favorites': 'Remove from the favorites',
  'page.journal.details.add-to-favorites': 'Add to favorites',
  'page.journal.details.remove-from-archive': 'Restore from the archive',
  'page.journal.details.add-to-archive': 'Remove to archive',
  'page.journal.details.contact-duplication-warning': 'Attention, the contact is also registered in the journal of other partners!',
  'page.journal.details.give-product.success-message': 'Activation request is processing. Please wait a few minutes.',
  'page.journal.details.give-product.error-message': 'There was an error sending your request. Please contact support service',
  'page.journal.details.give-product.gift-description': 'You are going to pay {productName}',
  'page.journal.details.give-product.will-debited': 'Your internal account will be debited for',
  'page.journal.details.give-product.confirm-text': 'Confirm the operation?',
  'page.journal.details.give-product.confirm.yes': 'Yes',
  'page.journal.details.give-product.confirm.cancel': 'Cancel',
  'page.journal.details.give-product.title': 'Gift to a partner',
  'page.journal.details.give-product.give-product': 'Give a product',
  'page.journal.details.give-product.select-product': 'Select the product',
  'page.journal.details.give-product.give': 'Give',
  'page.journal.details.give-product.not-enough-money': 'Not enough money in your internal account',
  'page.journal.details.give-product.not-enough-money-amount': 'Missing Amount:',
  'page.journal.details.give-product.select-product.empty': 'Product list is empty',
  'page.journal.details.is-shared': 'Contact received from {name}',
  'page.journal.filter.search-placeholder': 'Name, phone, email, tags',
  'page.journal.filter.period-placeholder': 'Specify a period',
  'page.journal.filter.reset': 'Reset filter',
  'page.journal.filter.period.primary': 'Main',
  'page.journal.filter.period.favorites': 'Favorites',
  'page.journal.filter.period.archive': 'Archive',
  'page.journal.filter.isBoughtBaseProduct': 'Master Kit is purchased',
  'page.journal.filter.isNotBoughtBaseProduct': 'Master Kit is not purchased',
  'page.journal.filter.isNotBoughtBaseProduct.tooltip': "Show only contacts who have not purchased the Master Kit",
  'page.journal.tasks-list.filter.state.finished': 'Completed',
  'page.journal.tasks-list.filter.state.unfinished': 'Planned',
  'page.journal.tasks-list.table.deadline': 'Deadline',
  'page.journal.tasks-list.table.date-time': 'Date and time',
  'page.journal.tasks-list.table.task-title': 'Task',
  'page.journal.tasks-list.table.task-result': 'Result',
  'page.journal.tasks-list.table.contact': 'Contact',
  'page.journal.utils.today': 'today',
  'page.journal.utils.yesterday': 'yesterday',
  'page.journal.at': 'at',
  'page.journal.utils.all-periods': 'For all the time',
  'page.journal.utils.added-today': 'For today',
  'page.journal.utils.added-last-week': 'For a week',
  'page.journal.utils.added-last-month': 'For a month',
  'page.journal.utils.added-last-year': 'For a year',
  'page.journal.contact.new': 'New',
  'page.journal.add-new.error.already-exists': 'Contact with this email or phone is already in the system',
  'page.journal.details.change-owner.title': 'Transfer contact to partner',
  'page.journal.details.change-owner.tooltip-title': 'Transfer contact to partner',
  'page.journal.details.change-owner.partner.placeholder': 'Partner',
  'page.journal.details.change-owner.partner.tip': 'Enter partner username',
  'page.journal.details.change-owner.send': 'Submit',
  'page.journal.details.change-owner.i-confirm': 'Confirm',
  'page.journal.details.change-owner.cancel': 'Cancel',
  'page.journal.details.change-owner.confirmation-text': 'You are going to transfer the contact to the partner {firstname} {lastname}\nContact will remove from your journal\nDo you confirm the operation?',
  'page.journal.details.change-owner.success-message': 'Contact {contactName} successfully transferred to partner {firstname} {lastname}',
  // photobank
  'page.photobank.description': 'Here you can find all Super Ego videos, from the Master Kit video to the vivid memories of the promo. Share these videos with your friends, customers and partners! Please note that links are not referral',
  'page.photobank.download': 'Download',
  // files
  'page.files.download': 'Download',
  // videobank
  'page.videobank.description': 'Here you can find all Super Ego videos, from the Master Kit video to the vivid memories of the promo. Share these videos with your friends, customers and partners! Please note that links are not referral',
  'page.videobank.action.open': 'Open',
  'page.videobank.action.copy-link': 'Copy link',
  'page.videobank.action.copy-link.success': 'Link copied successfully',
  'page.videobank.action.copy-link.error': 'Failed to copy link',
  // sales report
  'page.sales-report.table.title': 'Product',
  'page.sales-report.table.price': 'Price',
  'page.sales-report.table.count': 'Count',
  'page.sales-report.table.comission': 'Commissions',
  'page.sales-report.table.totalAmount': 'Total',
  'page.sales-report.table.total': 'Total',
  'page.sales-report.table.showDetails': 'Details',
  // 'page.sales-report.filter.product': 'Product',
  'page.sales-report.filter.category': 'Category',
  'page.sales-report.filter.partner': 'Partner',
  'page.sales-report.filter.partner-placeholder': 'Input username, phone or email',
  'page.sales-report.filter.from': 'Date from',
  'page.sales-report.filter.to': 'Date to',
  'page.sales-report.filter.reset': 'Reset',
  'page.sales-report.details.table.id': 'ID',
  'page.sales-report.details.table.buyer': 'Buyer',
  'page.sales-report.details.table.time': 'Payment date',
  'page.sales-report.details.table.price': 'Price',
  'page.sales-report.details.table.commission': 'Comission',
  // business reputation intro
  'page.business-reputation-intro.title': 'Business Reputation',
  'page.business-reputation-intro.step-1.title-1': 'Meet',
  'page.business-reputation-intro.step-1.title-2': 'Business Reputation!',
  'page.business-reputation-intro.step-1.text': 'We adapted Performance Review, a system used by the world\'s leading IT-companies to assess employee motivation and engagement. \n\nWe are now integrating this system to our partner network!',
  'page.business-reputation-intro.step-1.go-next-button': 'How does it work?',
  'page.business-reputation-intro.step-2.title': 'How does it work?',
  'page.business-reputation-intro.step-2.text': 'We collect feedback using anonymous surveys about your interactions with your clients, mentors, and team.\n\nYou\'ll also be asked to evaluate your mentor and team members.\n\nUsing a special formula we convert the feedback we receive into a rating — Business Reputation (BR).\n\nThis rating will be displayed in the upper left corner in the partner account next to the available funds. ',
  'page.business-reputation-intro.step-2.go-next-button': 'What does it give me?',
  'page.business-reputation-intro.step-3.title': 'What does it give me?',
  'page.business-reputation-intro.step-3.text': 'Business Reputation (BR) rating helps us understand which partners are more loyal to the business and as engaged as possible. \n\nYou\'ll also receive feedback about your "weak" spots and understand what you should work on.\n\nIn the future, partners with higher BR ratings will have access to new exclusive opportunities.\n\nAnd vice versa, partners with low and negative ratings will be subject to restrictions.',
  'page.business-reputation-intro.step-3.go-next-button': 'I understand',
  'page.business-reputation-intro.step-3.show-more-button': 'Learn more about Business Reputation',
  'page.business-reputation-intro.step-3.long-text': 'businessReputationDocEn',
  // 404
  'page.404.title': 'Page not found',
  'page.404.go-home': 'Main page',
  // 403
  'page.403.title': 'Access denied - not enough rights',
  'page.403.title-short': 'Access denied',
  'page.403.description': 'Not enough rights to view this resource',
  'page.403.go-home': 'Main page',
  // ERRORS
  'error.no-access-short': 'Access error',
  'error.request-error': 'Request execution error',
  'error.no-access': 'Access error. Not enough rights to perform the operation',
  'error.internal-server-error': 'An internal server error occurred during the execution of the request',
  'error.no-connection': 'Connection error. Check your Internet connection.',
}

const cache = createIntlCache()

const intl = createIntl({
  locale: 'en',
  messages,
  antdData
}, cache)

export default intl;
